import { Commit } from 'vuex';
import { RouteConfig } from 'vue-router';
import { USER } from '../mutation_types';
import { IAUTH } from '../state.d';

const login: Function = (context: { commit: Commit },
  value: { auth: IAUTH, menuRoutes: Array<RouteConfig>, btns: Array<string> }) => {
  context.commit(USER.SET_USER_AUTH, value.auth);
  context.commit(USER.SET_USER_MENU_ROUTES, value.menuRoutes);
  context.commit(USER.SET_USER_BTNS, value.btns);
};

const loginOut: Function = () => {
  sessionStorage.removeItem('auth');
  sessionStorage.removeItem('menuRoutes');
  sessionStorage.removeItem('btns');
  sessionStorage.removeItem('openTags');
  window.location.reload();
};

export default {
  login,
  loginOut,
};
